import { gql } from "graphql-request";

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation UpdateUserPassword(
    $newPassword: String!
    $previousPassword: String
  ) {
    updateUserPassword(
      newPassword: $newPassword
      previousPassword: $previousPassword
    ) {
      data
    }
  }
`;

export const CREATE_SUPPORT_MUTATION = gql`
  mutation CreateSupport($support: SupportInput!) {
    createSupport(support: $support) {
      data
    }
  }
`;

export const UPDATE_USER_BY_ID = gql`
  mutation UpdateUserById($userId: String!, $userData: UpdateUserInput!) {
    updateUserById(userId: $userId, userData: $userData) {
      data
    }
  }
`;

export const UPDATE_COMPANY_INFO = gql`
  mutation Mutation($tenantData: UpdateTenantInput!, $tenantId: String) {
    updateCompanyInfo(tenantData: $tenantData, tenantId: $tenantId) {
      data
    }
  }
`;

export const GET_COMPANY_INFO_BY_ID = gql`
  query Query {
    getTenantById {
      data {
        companyName
        companyEmail
        businessAddress
        companyLogo
      }
    }
  }
`;
